import React, { useState, useEffect } from "react";
import { loginFetch } from "../../../Redux/usersReduce";
import { useDispatch, useSelector } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { sendMail } from "../../../Redux/sendMailReduce";
import Configuration from "../../../configuration";
import { Button, Card, Form, Container, Col, Row } from "react-bootstrap";


function LoginPage() {
  const url = Configuration.BACK_BASEURL;

  const notifyErr = (msg) =>
    toast.error(
      <strong>

        {msg}
      </strong>
    );

 const notifySucc = (msg) =>
    toast.success(
      <strong>

        {msg}
      </strong>
    );

  const settings = useSelector((state) => state.settings.entities);

  if (settings.length > 0) {
    document.title = settings[0].name;
  }

  const dispatch = useDispatch();
  const [cardClasses, setCardClasses] = useState("card-hidden");
  const [forgotPassword, setForgotPassword] = useState(false);
  const [email, setEmail] = useState("");
  const [login, setLogin] = useState("");
  const [password, setPassword] = useState("");

  useEffect(() => {
    setTimeout(function () {
      setCardClasses("");
    }, 1000);
  }, []);

  function loginChange(event) {
    setLogin(event.target.value);
  }

  function passwordChange(event) {
    setPassword(event.target.value);
  }

  function enterKeyPressed(event) {
    if (event.charCode === 13) {
      submitForm();
      return true;
    } else {
      return false;
    }
  }

  const handleForgotPasswordClick = () => {
    setForgotPassword(true);
  };

  const handleLoginClick = () => {
    setForgotPassword(false);
  };

  const submitForm = (event) => {
    const promise = new Promise((resolve, reject) => {
      setTimeout(async () => {
        var root = await dispatch(
          loginFetch({ login: login, password: password })
        );
        var entities = root.payload;
        resolve(entities);
      }, 0);
    });

    promise.then((value) => {
      if (value.message !== true) {
        notifyErr(value.message);
      } else {
        localStorage.setItem("x-access-token", value.token);
        window.location.replace("/");
      }
    });
  };

  function sendEmail() {
    if (email !== "") {
      dispatch(sendMail({ url, email })).then((e1) => {
        if (e1.payload === false) {
          notifyErr("Vérifier votre email");
        } else {
          notifySucc("Votre email a été envoyé avec succès");
          window.location.replace("/login");
        }
      });
    } else {
      notifyErr("Vérifier vos données");
    }
  }

  return (
    <>
      <ToastContainer />
      <div className="login-page full-gray section-image" data-color="black">

        <Row>

          <Col lg="12">
            <div className="block-log full-page login-page">
              <div className="content d-flex align-items-center p-0">

                {/* <Col className="mx-auto" lg="5"> */}
                <Col lg="4" md="8" sm="8" xs="12">
                  <Form
                    action=""
                    className="form"
                    method=""
                    onSubmit={submitForm}
                  >
                    <Card className={"card-login " + cardClasses}>
                      <div className="img-log">
                        {settings.length > 0 ? (
                          <>
                            <img
                              src={require("../../../assets/img/" + settings[0].logo)}
                              alt="medicacom"

                            />

                          </>) : (""
                        )}
                      </div>
                      <br></br>
                      <Card.Body>
                        {!forgotPassword ? (
                          <>
                            <Form.Group className="margin-bottom" data-icon="">
                              <label>Identifiant</label>
                              <Form.Control
                                onKeyPress={enterKeyPressed}
                                placeholder="Identifiant"
                                type="text"
                                onChange={loginChange}
                              />
                            </Form.Group>

                            <Form.Group className="margin-bottom" data-icon="">
                              <label>Mot de passe</label>
                              <Form.Control
                                placeholder="Password"
                                onKeyPress={enterKeyPressed}
                                onChange={passwordChange}
                                type="password"
                              />
                            </Form.Group>
                          </>
                        ) : (
                          <Form.Group className="margin-bottom">
                            <label>Email</label>
                            <Form.Control
                              placeholder="Email"
                              type="email"
                              onChange={(e) => setEmail(e.target.value)}
                              value={email}
                            ></Form.Control>
                          </Form.Group>
                        )}
                      </Card.Body>
                      <Card.Footer className="ml-auto mr-auto">
                        <br></br>
                        {!forgotPassword ? (
                          <Button
                            className="custom-blue-btn"
                            type="button"
                            onClick={submitForm}
                          >
                            Connexion
                          </Button>

                        ) : (
                          <div>
                            <Button
                              className="btn-wd mx-2"
                              type="button"
                              variant="danger"
                              onClick={handleLoginClick}
                            >
                              Annuler
                            </Button>
                            <Button
                              className="btn-wd"
                              type="button"
                              variant="info"
                              onClick={sendEmail}
                            >
                              Envoyer
                            </Button>

                          </div>
                        )}
                  <div class="logo-footer"><a href="https://medicacom.tn" target="_blank"><img src={require("../../../assets/img/medicacom.png")}></img>
                </a >
                </div>
                        <br clear="all"></br>
                        <br clear="all"></br>
                        {!forgotPassword ? (
                          <div className="login-footer-links">
                            <a onClick={handleForgotPasswordClick}>Mot de passe oublié?</a>
                            <a href="mailto:support@medis.com.tn">Contact Support</a>
                          </div>
                        ) : null}

                      </Card.Footer>
                    </Card>

                  </Form>
                </Col>
               
              </div>
              {/* <div
                className="full-page-background"
                style={{ backgroundImage: "url(" + require("../../../assets/img/1.jpg") + ")", }}
              ></div> */}
            </div>
          </Col>
        </Row>
      </div>
    </>
  );
}


export default LoginPage;

